// extracted by mini-css-extract-plugin
export default {"question":"gw2FM7","title":"OFrJY5","description":"JHyoY0"};